import axios from '../axios';
import config from '../../config';
export default {
    // 建立webrtc连接
    connectWebrtc(cameraId, peerId) {
        return axios(`${config.staigeUrl}/staige/camera/${cameraId}/webrtc/${peerId}`, {
            method: 'post',
            handleTipsBySelf: true,
            timeout: 100000,
        });
    },
    // 用户场地列表
    getPitchesList(params) {
        return axios(`${config.staigeUrl}/pitch/user/pitches`, {
            method: 'get',
            params,
        });
    },
    // 预约场地列表 /pitch/{id}/reservations
    getReservationPitch(id, isPedding = true) {
        return axios(`${config.staigeUrl}/pitch/${id}/reservations?ignore_past=${isPedding}`, {
            method: 'get',
        });
    },
    // 账号列表 /vi/account/tenant/{tenantId}/accounts
    getAccounts(tenantId) {
        return axios(`${config.staigeUrl}/vi/account/tenant/${tenantId}/accounts`, {
            method: 'get',
            paramsToken: 'custom-token',
        });
    },
    // 创建账号 /vi/account
    addAccount(data) {
        return axios(`${config.staigeUrl}/vi/account`, {
            method: 'post',
            data,
        });
    },
    // 编辑账号 /vi/account/{id}
    updateAccount(data, id) {
        return axios(`${config.staigeUrl}/vi/account/${id}`, {
            method: 'put',
            data,
        });
    },
    // 删除账号 /vi/account/{id}
    delAccount(id) {
        return axios(`${config.staigeUrl}/vi/account/${id}`, {
            method: 'delete',
        });
    },
    // 账单余额/tenant/{id}/balance
    getBalance(id) {
        return axios(`${config.staigeUrl}/tenant/${id}/balance`, {
            method: 'get',
        });
    },
    // 机构账单列表 /bill/tenant/{tenantId}/bills
    getBalanceList(tenantId) {
        return axios(`${config.staigeUrl}/bill/tenant/${tenantId}/bills`, {
            method: 'get',
        });
    },
    // 机构场地列表 /pitch/tenant/{id}/pitches
    getPitches(id) {
        return axios(`${config.staigeUrl}/pitch/tenant/${id}/pitches`, {
            method: 'get',
        });
    },
};
